<hlm-popover
  align="end"
  [state]="selectionOverlayState()"
  (stateChanged)="onSelectionStateChanged($event)"
>
  <button
    type="button"
    hlmPopoverTrigger
    class="member-badge-group__badges"
    [class.member-badge-group__badges--selectable]="store.selectable()"
    [attr.aria-haspopup]="store.selectable() ? 'listbox' : null"
    [attr.aria-expanded]="store.selectable() ? store.isActive() : null"
    (mouseenter)="showTooltipPopover()"
    (mouseleave)="scheduleHideTooltip()"
    (focusin)="showTooltipPopover()"
    (focusout)="scheduleHideTooltip()"
    (click)="onBadgeClick()"
    (keydown)="onBadgeKeydown($event)"
  >
    @for (member of store.visibleMembers(); track $index; let i = $index) {
      <ocp-avatar
        [userInitials]="member.initials"
        [colorSeed]="member.email"
        size="md"
        class="member-badge-group__avatar"
        [style]="{ 'z-index': store.visibleMembers().length - i }"
      />
    }
    @if (store.hasOverflow()) {
      <span class="member-badge-group__overflow">+ {{ store.overflowCount() }}</span>
    }
  </button>

  @if (store.selectable()) {
    <hlm-popover-content *hlmPopoverPortal class="p-3">
      <ocp-member-select-panel
        #panel
        [options]="store.options()"
        [selectedIds]="store.localSelectedIds()"
        (memberToggled)="onMemberToggled($event)"
        (closeRequested)="closePopover()"
      />
    </hlm-popover-content>
  }
</hlm-popover>

@if (tooltipVisible()) {
  <div
    #tooltip
    class="member-badge-group-hover"
    [style.top]="tooltipPosition()?.top"
    [style.left]="tooltipPosition()?.left"
    [style.transform]="'translateY(calc(-100% - 8px))'"
    (mouseenter)="cancelHideTooltip()"
    (mouseleave)="scheduleHideTooltip()"
  >
    <div class="member-badge-group-hover__title">
      {{ 'member-badge-group.assignees-count' | translate: { count: store.members().length } }}
    </div>
    <div class="member-badge-group-hover__list">
      @for (member of store.members(); track $index) {
        <div class="member-badge-group-hover__item">
          <ocp-avatar userInitials="" [colorSeed]="member.email" size="xs" />
          <span class="member-badge-group-hover__name">{{ member.name }}</span>
        </div>
      }
    </div>
  </div>
}
